import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const SubscriptionFilter = <SelectField
    choices={ [
        {
            id: '1',
            name: 'actions.yes',
        },
        {
            id: '0',
            name: 'actions.no',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='resources.subscriptions.show.subscription'
    source='is_subscription'
/>;

export default SubscriptionFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/SubscriptionFilter.js